import { App } from './core/App.js'

const canvas = document.querySelector('canvas.webgl')

if (canvas) {
  const app = new App(canvas)
  
  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    app.destroy()
  })
} else {
  console.error('Canvas element not found')
}
